import { Component, OnInit } from "@angular/core";
import { PushparentQuestionBankService } from "../../shared/services/push-parent-question-bank/push-parent-question-bank.service";
import { ActivatedRoute } from "@angular/router";
import { first } from "rxjs/operators";
import { Router } from "@angular/router";
import * as moment from "moment";
import Swal from "sweetalert2";
import { AlertService } from "../../shared/services/alert/alert.service";

@Component({
  selector: "app-push-parent-question-bank",
  templateUrl: "./push-parent-question-bank.component.html",
  styleUrls: ["./push-parent-question-bank.component.scss"]
})
export class PushParentQuestionBankComponent implements OnInit {
  slots: any = [];
  modules: any = [];
  data: any;
  qbankid;
  date: any;

  pushparentqb: any = {
    date: "",
    batch: "",
    module: ""
  };

  sender = "push-parent-question-bank";

  constructor(
    private pushparentQbApi: PushparentQuestionBankService,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,

  ) {}

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.qbankid = params.get("id");
      if (this.qbankid !== "new") {
        this.getQbankbyId(this.qbankid);
      }
    });
  }

  onSave() {

    if (!this.pushparentqb.date) {
      this.alertService.err(this.sender, "Question Bank date cannot be Blank");
      return false;
    }
    if (!this.pushparentqb.batch) {
      this.alertService.err(this.sender, "Question Bank Batch cannot be Blank");
      return false;
    }
    if (!this.pushparentqb.module) {
      this.alertService.err(this.sender, "Question Bank module cannot be Blank");
      return false;
    }
    if (this.pushparentqb.date) {
      this.pushparentqb.date = this.getDate(this.pushparentqb.date);
    }

    this.pushparentQbApi
      .savePushQuestionBank(this.pushparentqb)
      .pipe(first())
      .subscribe(res => {
        this.alertService.show(this.sender, "Question bank saved..");
        this.router.navigate(["manager/push-parent-question-bank-list/"]);
      });
  }

  getDate(date) {
    return moment(date)
      .format("DD-MM-YYYY")
      .toString();
  }
  getQbankbyId(id) {
    this.pushparentQbApi
      .getQbankbyId(id)
      .pipe(first())
      .subscribe(res => {
        this.pushparentqb = res;
        if (!this.pushparentqb.date) {
          this.pushparentqb.date = moment(
            this.pushparentqb.date,
            "DD-MM-YYYY"
          ).toDate();
        }
      });
  }

  onCancel() {
    this.router.navigate(["manager/push-parent-question-bank-list/"]);
  }
  deleteQbank() {
    Swal.fire({
      title: "Are you sure?",
      text:
        "Parent Question Bank data will be deleted. This action can't be reversed!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it"
    }).then(result => {
      if (result.value) {
        Swal.fire("Deleted!", "Parent Question Bank is Deleted.", "success");

        this.pushparentQbApi
          .deleteQbank(this.qbankid)
          .pipe(first())
          .subscribe(res => {
            this.router.navigate(["manager/push-parent-question-bank-list"]);
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelled", "Parent Question Bank is Deleted:)", "error");
      }
    });
  }
}
